module.exports = __webpack_public_path__ + "static/media/solutionm11.ab4285f0.jpg";